if (!customElements.get("selling-points-slider")) {
  customElements.define(
    "selling-points-slider",
    class SellingPointsSlider extends HTMLElement {
      constructor() {
        super();
        this.sliderRef = this.querySelector("[data-slider]");
        this.nextRef = this.querySelector('[data-navigation="next"]') || null;
        this.previousRef = this.querySelector('[data-navigation="prev"]') || null;
        this.paginationRef = this.querySelector("[data-pagination]") || null;
        this.initSlider = this.initSlider.bind(this);
      }

      connectedCallback() {
        this.initSlider();
      }

      initSlider() {
        this.swiper = new Swiper(this.sliderRef, {
          // Optional parameters
          slidesPerView: 1,
          loop: false,
          autoplay: false,

          keyboard: {
            enabled: true,
          },

          // If we need pagination
          pagination: {
            el: this.paginationRef,
            clickable: true,
          },

          // Navigation arrows
          navigation: {
            nextEl: this.nextRef,
            prevEl: this.previousRef,
          },
          breakpoints: {
            768: {
              slidesPerView: 3,
            },
          },
        });
      }

      disconnectedCallback() {
        this.swiper.destroy();
      }
    }
  );
}
